import { notification } from "antd";
import store from "data/store";
import api from "services/api";

class TarotsService {
  init = async () => {
    try {
      const { data } = await api.getTarots();
      store.tarots.set(data);
    } catch (error) {
      console.log("error", error);
      notification.error({ message: "Tarots can't be loaded" });
    }
  };
}

export default new TarotsService();
